module.exports = __webpack_public_path__ + "Roboto-LightItalic.cdd1c486770034a6122e.eot";


//////////////////
// WEBPACK FOOTER
// /Users/rujuta/Desktop/Projects/agiletimes-master/node_modules/roboto-fontface/fonts/roboto/Roboto-LightItalic.eot
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-LightItalic.eot
// module chunks = styles